'use client';
import { useRedirect } from '@/locale/hooks';

export default function Index() {
  /*
   * Replace the elements below with your own.
   *
   * Note: The corresponding styles are in the ./index.scss file.
   */
  useRedirect();
  return <></>;
}
